import { getLoadablePage } from 'site-modules/shared/components/loadable-page/loadable-page';

export const cpoWarrantyRoutes = [
  {
    path: '/cpo-warranty/',
    exact: true,
    page: getLoadablePage(
      () => import(/* webpackChunkName: "cpo-warranty" */ '../pages/cpo-warranty/cpo-warranty-definition')
    ),
    chunkName: 'cpo-warranty',
  },
];
